<template>
  <div class="addressBox" >
    <el-table :data="[{}]"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border >
      <el-table-column label="支出方式" min-width="100">
        <template slot="header" >
          <div><span class="red">*</span>支出方式</div>
        </template>
        <template >
          <div>
            <el-form-item label=""    class="table_error" prop="expenditurePattern">
              <el-select  v-model="goodform.expenditurePattern"  placeholder="请选择"  @change="zcfsChange">
                <el-option v-for="item in ZHFSlist"  :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费计价" min-width="100">
        <template slot="header" >
          <div><span class="red">*</span>运费计价</div>
        </template>
        <template >
          <div>
            <el-form-item label=""    class="table_error" prop="freightPricingType">
              <el-select  v-model="goodform.freightPricingType"  placeholder="请选择" @change="jijiaChange">
                <template  v-for="item in SRJJlist">
                     <el-option  :label="item.showName" v-if="item.showName.includes(goodform.measuringUnit)||item.showName=='包干'" :value="item.itemNo" :key="item.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费单价(元)" min-width="100">
        <template slot="header" >
          <div><span class="red">*</span>运费单价(元)</div>
        </template>
        <template >
          <div>
            <el-form-item label=""   class="table_error" prop="freightUnitPrice" v-if="goodform.freightPricingType!=1">
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.freightUnitPrice"  ></el-input>
            </el-form-item>
            <span v-else>-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费金额(元)" min-width="100">
        <template slot="header" >
          <div><span class="red">*</span>运费金额(元)</div>
        </template>
        <template >
          <div>
            <el-form-item label=""  class="table_error"  prop="freightAmount">
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.freightAmount"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="服务费率%" min-width="120" >
        <template slot="header" >
          <div><span class="red">*</span>服务费率%</div>
        </template>
        <template >
          <div>
            <el-form-item label=""  class="table_error" prop="serviceRate" >
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.serviceRate"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="服务费(元)" min-width="120" >
        <template slot="header" >
          <div><span class="red">*</span>服务费(元)</div>
        </template>
        <template >
          <div>
            <el-form-item label=""  class="table_error"  prop="serviceCharge">
              <el-input  placeholder=""  v-number-input.float="2" :readonly="true"  maxlength="8" v-model="goodform.serviceCharge"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <!-- v-if="fuwufeiFLag==1" -->
      <el-table-column label="运费税率%" min-width="120" >
        <template slot="header" >
          <div><span class="red">*</span>运费税率%</div>
        </template>
        <template >
          <div>
            <el-form-item label=""  class="table_error" prop="freightTaxRate" >
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.freightTaxRate"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getDictionaryDetailList } from '@/api/newTMS'
import { toFixed } from '@/utils/util'
export default {
  name: 'shouru',
  props: {
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      ZHFSlist: [],
      SRJJlist: []
    }
  },
  created () {
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (!this.goodform.freightTaxRate) {
      this.$set(this.goodform, 'freightTaxRate', 9)
    }
    if (!this.goodform.serviceRate) {
      this.$set(this.goodform, 'serviceRate', 0)
    }
    if (!this.goodform.serviceCharge) {
      this.$set(this.goodform, 'serviceCharge', 0.00)
    }
    getDictionaryDetailList({ dictionaryType: 'down_settlement_type' }).then(res => { this.ZHFSlist = res })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => { this.SRJJlist = res })
  },
  methods: {
    // 支出方式修改
    zcfsChange (e) {
      let json = this.ZHFSlist.filter(item => item.itemNo == e)
      this.goodform.expenditurePatternName = json[0].showName
    },
    // 运费计价修改
    jijiaChange (e) {
      let json = this.SRJJlist.filter(item => item.itemNo == e)
      this.goodform.freightPricingTypeName = json[0].showName
      if (this.goodform.freightPricingType == 1) {
        this.$set(this.goodform, 'freightUnitPrice', '')
        this.$set(this.goodform, 'freightAmount', '')
      } else {
        this.$set(this.goodform, 'freightUnitPrice', '')
        this.$set(this.goodform, 'freightAmount', '')
      }
    }

  },
  watch: {
    goodform: {
      handler (newName, oldName) {
        if (this.goodform.orderWeight && this.goodform.freightUnitPrice) {
          this.$set(this.goodform, 'freightAmount', toFixed(accMul(this.goodform.orderWeight, this.goodform.freightUnitPrice), 2))
        }
        if (this.goodform.freightAmount && this.goodform.serviceRate) {
          let n = this.goodform.serviceRate / 100
          this.$set(this.goodform, 'serviceCharge', toFixed(accMul(this.goodform.freightAmount, n), 2))
        } else {
          // this.$set(this.goodform, 'serviceCharge', 0)
        }
        function accMul (arg1, arg2) {
          var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {
          }
          try {
            m += s2.split('.')[1].length
          } catch (e) {
          }

          return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
        }
      },
      deep: true
    }
  }

}
</script>

<style scoped lang='less'>
.tableBox{
  min-width:900px;
}
.addressBox /deep/.el-input__inner{
  width: 100px;
}
</style>
